<!-- <ngx-calendar></ngx-calendar> -->


<body >
  <div class="content-wrapper " style="width: 100%;">
    <div class="col-12 group2 d-flex justify-content-center">
      <h5 class="titlePage font-weight-bold ">Type de {{type}} </h5>
    </div>

  </div>
  <ng-container *ngIf="type == 'demande';else otherType">
    <div class="row m-auto" >
      <ng-container *ngIf="items.length>0; else empty">
        <div class="col col-md-4 col-lg-4 col-sm-12 mt-4 text-center flex-wrap" *ngFor="let item of items ">
          <div class="d-flex justify-content-center">
    
            <div class="addButton" (click)="openModalAddDemandeVisite(item.titre,item)">
             <div class="button text-nowrap " style="font-size: 11px;">
                <div class="d-flex justify-content-between ">
                  <!-- <i class="fas fa-solid fa-file-import circle mt-1  m-auto " style="font-size: 20px;"></i> -->
                  <span style="font-size: 11px;" class="m-auto ml-2">{{item.titre}}</span>
                </div>
    
                </div>
          </div>
          </div>
    
        </div>
      </ng-container>
      <ng-template #empty>
        <p class="text-center">Acune demande trouvée, verifiez qu'il y a une type de demande configurée pour ce tribunal</p>
      </ng-template>
      
  
  
    </div>
  </ng-container>

  <ng-template #otherType>
    <div class="d-flex flex-wrap justify-content-between">
      <div class="col-sm-10 col-md-4 justify-content-center">
        <ng-container >
          <div class="container shadow ">
            <!-- heading, tagline and search box -->
            <header class="head">
              <h6>liste actions</h6>
              <!-- <p class="tag-line">At the end of the day, clear the tasks</p> -->
              <input type="text" placeholder="rechercher" class="input-search" [(ngModel)]="searchText" (input)="onSearch()">
            </header>
        
            <!-- complete list container -->
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col"></th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="filteredActionPermises.length>0;else additem">
                  <tr *ngFor="let task of filteredActionPermises | paginate: { itemsPerPage: 5, currentPage: pageactions, id: 'action' }" class="text-container text-center"  [class.selected]="task === selectedTask" (click)="selectTask(task)">
                    <td class="text" >{{ task }}</td>
                    <td> <i class="fas fa-solid fa-pen" style="font-size: 15px;"></i></td>
                  </tr>
                </ng-container>
                <ng-template #additem> <br>
                  <tr>
                    <span class="text" id="box" (click)="addAction(searchText)" ><a>Ajouter: {{ searchText }}</a> </span>
                  </tr>
                  
             
             </ng-template>
              </tbody>
            </table>
            <!-- <ul class="list-container d-flex flex-column justify-content-center align-items-center">
              <ng-container *ngIf="filteredActionPermises.length>0;else additem">
                <li *ngFor="let task of filteredActionPermises | paginate: { itemsPerPage: 5, currentPage: pageactions, id: 'action' }" class="text-container text-center" (click)="onfilter(task)" [class.selected]="task === selectedTask" (click)="selectTask(task)">
                  <span class="text" id="box">{{ task }}</span>
                </li>
                <pagination-controls style="margin-left: -20px;" (pageChange)="pageactions = $event" previousLabel="" nextLabel=""
                  responsive="true" [id]="'action'"></pagination-controls>
              </ng-container>
              <ng-template #additem> <br>
                
                   <span class="text" id="box" (click)="addAction(searchText)" ><a>Ajouter: {{ searchText }}</a> </span>
              
              </ng-template>
             
            </ul> -->
            
  
        
            <!-- form to add new list -->
            <!-- <form class=" d-flex flex-column justify-content-center " (ngSubmit)="addAction()">
              <input class="form-control mb-3" type="text" placeholder="ajouter une action" [(ngModel)]="newTaskText" name="taskText" required>
              <button class="btn btn-sm btn-outline-primary" type="submit">Enregistrer</button><br>
            </form> -->
          </div><br>
        </ng-container>
      </div>
      
      
      <ng-container>
        <div class="d-flex flex-column col-sm-10 col-md-8 shadow">
          <p class="text-center">{{selectedTask}} </p>
          <div class=" d-flex justify-content-start flex-wrap ">
            <div class="mr-1" *ngFor="let item of filtered_items ">
              <div class="addButton" (click)="openModalAddDemandeVisite(item.titre,item)" >
                <div class="button text-nowrap " style="font-size: 11px;">
                   <div class="d-flex justify-content-between ">
                     <!-- <i class="fas fa-solid fa-file-import circle mt-1  m-auto " style="font-size: 20px;"></i> -->
                     <span style="font-size: 11px;" class="m-auto ml-2">{{item.titre}}</span>
                   </div>
       
                   </div>
             </div>&nbsp;
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-template>
  <br><br>




</body>

